import { apiClient } from 'config/api';

export type ResolveDecision = 'APPROVED' | 'REJECTED';

/**
 * Approves or rejects a pending prospect registration
 * @param body - body payload request
 * @param body.id - pending prospect id
 * @param body.decision - APPROVED or REJECTED
 */
async function postResolvePendingProspect({
  id,
  decision,
}: {
  id: string;
  decision: ResolveDecision;
}) {
  const url = `/v3/prospect/pending/${id}/resolve`;
  const response = await apiClient.post(url, { decision });
  return response.data;
}

export default postResolvePendingProspect;
